import React, { memo } from 'react';
import { SvgIcon, SvgIconProps, Theme, useTheme } from '@mui/material';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function Profile({ dark = false, ...rest }: Props) {
  const { palette }: Theme = useTheme();
  const foreground = dark ? palette.secondary.lightest : palette.primary.dark;

  return (
    <SvgIcon viewBox="0 0 34 34" {...rest}>
      <g fill="none" fillRule="evenodd">
        <path d="M17 1.3a15.7 15.7 0 100 31.4 15.7 15.7 0 000-31.4z" stroke={foreground} strokeWidth={2} />
        <path
          d="M17 5.3a5 5 0 110 10 5 5 0 010-10zM17 29a12 12 0 01-10-5.4c0-3.3 6.7-5.1 10-5.1s10 1.8 10 5.1A12 12 0 0117 29z"
          fill={foreground}
        />
      </g>
    </SvgIcon>
  );
}

export default memo(Profile);
